import angular from "angular";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";
import { IApiComarque, IApiComerques } from "./api.model";

export class ComarquesService {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/comarques/`;
  private comarques: IApiComarque[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: ng.IHttpService
  ) { }

  init(): angular.IPromise<IApiComarque[]> {
    return this.$http.get<IApiComerques>(`${this.apiurl}findAll?`)
      .then((response: any) => {
        this.comarques = response.data.comarques;
        return this.comarques;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.comarques;
      });
  }
}

angularJsApp.service(AppServicesEnum.COMARQUES_SERVICE, ComarquesService);